import { render, staticRenderFns } from "./BattlePage.vue?vue&type=template&id=6241ef8c&"
import script from "./BattlePage.vue?vue&type=script&lang=ts&"
export * from "./BattlePage.vue?vue&type=script&lang=ts&"
import style0 from "./BattlePage.vue?vue&type=style&index=0&id=6241ef8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports